const registerForm = () => {
    $('[data-toggle="register"]').click(function(e) {
        e.stopPropagation();
        $(this).parents('#login_content').toggleClass('open');
    });
}

const loginV3 = () => {
    $('#login-wrapper .btn-fab').click(function(e) {
        e.stopPropagation();
        $(this).parents('.card').toggleClass('active');
    });
}

export{loginV3,registerForm}



// WEBPACK FOOTER //
// ./js/modules/auth.js